import Logo from '@delmonicos/shared-design-system-core/assets/delmonicos-icons/svg/delmonicos-name.svg';
import {
  Icon,
  IconColor,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import classNames from 'classnames';

import * as css from './logo-cpms.module.scss';

interface LogoCPMSProps {
  className?: string;
}

export const LogoCPMS = ({ className }: LogoCPMSProps): React.JSX.Element => {
  return (
    <div className={classNames(css.logo, className)}>
      <Icon name="delmonicos" color={IconColor.Brand} />
      <Logo />
      <Text className={css.badge}>CPMS</Text>
    </div>
  );
};
